// Funciones para la gestión de usuarios
import axios from 'axios';
import { API_BASE_URL, handleApiError } from '../../config/apiConfig';

// Función para obtener todos los usuarios (requiere permisos de admin o moderador)
export const obtenerTodosUsuarios = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/obtener_todos_usuarios.php`, {
      withCredentials: true
    });

    return response.data;
  } catch (error) {
    console.error('Error al obtener todos los usuarios:', error);
    const errorMessage = handleApiError(error);
    return {
      success: false,
      message: error.response?.data?.message || errorMessage || 'Error al obtener todos los usuarios'
    };
  }
};

// Función para banear a un usuario
export const banearUsuario = async (userId, duracionDias) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/banear_usuario.php`, {
      user_id: userId,
      duracion_timeout: duracionDias
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });

    return response.data;
  } catch (error) {
    console.error('Error al banear usuario:', error);
    const errorMessage = handleApiError(error);
    return {
      success: false,
      message: error.response?.data?.message || errorMessage || 'Error al banear usuario'
    };
  }
};

// Función para desbanear a un usuario
export const desbanearUsuario = async (userId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/desbanear_usuario.php`, {
      user_id: userId
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });

    return response.data;
  } catch (error) {
    console.error('Error al desbanear usuario:', error);
    const errorMessage = handleApiError(error);
    return {
      success: false,
      message: error.response?.data?.message || errorMessage || 'Error al desbanear usuario'
    };
  }
};

// Función para actualizar el rol de un usuario
export const actualizarRolUsuario = async (userId, nuevoRol) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/actualizar_perfil.php`, {
      id: userId,
      rol: nuevoRol
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });

    return response.data;
  } catch (error) {
    console.error('Error al actualizar rol de usuario:', error);
    const errorMessage = handleApiError(error);
    return {
      success: false,
      message: error.response?.data?.message || errorMessage || 'Error al actualizar rol de usuario'
    };
  }
};

// Función para cambiar la contraseña del usuario
export const cambiarPassword = async (currentPassword, newPassword) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/cambiar_password.php`, {
      current_password: currentPassword,
      new_password: newPassword
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });

    return response.data;
  } catch (error) {
    console.error('Error al cambiar contraseña:', error);
    const errorMessage = handleApiError(error);
    return {
      success: false,
      message: error.response?.data?.message || errorMessage || 'Error al cambiar contraseña'
    };
  }
};

// Función para obtener usuarios conectados
export const obtenerUsuariosConectados = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/obtener_usuarios_conectados.php`, {
      withCredentials: true
    });

    return response.data;
  } catch (error) {
    console.error('Error al obtener usuarios conectados:', error);
    const errorMessage = handleApiError(error);
    return {
      success: false,
      message: error.response?.data?.message || errorMessage || 'Error al obtener usuarios conectados'
    };
  }
};

// Función para eliminar un usuario por ID.
// Permite autoeliminación del usuario autenticado y eliminación de terceros para admin.
export const eliminarUsuario = async (userId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/eliminar_usuario.php`, {
      user_id: userId
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });

    return response.data;
  } catch (error) {
    console.error('Error al eliminar usuario:', error);
    const errorMessage = handleApiError(error);
    return {
      success: false,
      message: error.response?.data?.message || errorMessage || 'Error al eliminar usuario'
    };
  }
};
